<template>
  <v-row justify="center">
    <v-dialog v-model="daysDialog" max-width="350px">
      <v-card>
        <v-card-title>보증기간 변경</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-4">
          <p class="font-weight-bold mt-7 body-2 black--text mb-2">
            보증기간 수정시 참고해주세요.
          </p>
          <p class="mb-0 font-weight-bold caption">
            보증기간은 고객에게 민감한 사항이므로
          </p>
          <p class="mb-0 font-weight-bold caption">
            고객이 인증받은 경우 협의 후 사용하시길 권장합니다.
          </p>

          <p class="font-weight-bold body-2 black--text text-truncate mt-7 mb-2">
            보증기간 선택
          </p>
          <v-menu v-model="startMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="startDate"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker v-model="startDate" @input="startMenu = false" locale="ko" :max="endDate"></v-date-picker> </v-menu
          >~
          <v-menu v-model="endMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="endDate"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker v-model="endDate" @input="endMenu = false" locale="ko" :min="startDate"></v-date-picker>
          </v-menu>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="daysDialog = false">닫기</v-btn>
          <v-btn color="blue darken-1" text @click.prevent="changeWarrantyPeriod">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      prd: null,
      startDate: "",
      endDate: "",
      startMenu: false,
      endMenu: false,
      daysDialog: false,
      textFileSize: {
        height: "50px",
        width: "110px",
      },
    };
  },
  mixins: [CommonMixin],
  methods: {
    daysClick: function(data) {
      this.prd = data;
      this.startDate = data.cert_validated_at.substr(0, 10);
      this.endDate = data.cert_expired_at.substr(0, 10);

      this.daysDialog = true;
    },
    /**
     * 날짜 변경
     */
    changeWarrantyPeriod: async function() {
      if (this.startDate === "" || this.endDate === "") {
        this.alertShow("보증기간을 입력해주세요.");
        return false;
      }
      let payload = {
        cert_validated_at: this.startDate + " 00:00:01",
        cert_expired_at: this.endDate + " 23:59:59",
      };

      try {
        await M.api(M.entry("/serials/range", this.prd.serial_number), payload);
        this.daysDialog = false;
        this.alertShow("정상적으로 보증기간이 변경되었습니다.");
        this.eventHub.$emit("execSearch", false);
      } catch (e) {
        if (e.response.status === 400) {
          this.alertShow("인증된 상품은 보증기간을 변경할수 없습니다.");
        }
      }
    },
  },
};
</script>
